import { injectReducer } from '@modules/reducers'
import { injectSagas } from '@modules/sagas'

// Sync route definition
export default (store: Store): RouteConfig => ({
  path: '/change-password',
  layout: true,
  getComponent: async () => {
    const ChangePasswordLayout = await import(
      /* webpackChunkName: "change-password-modules" */ './components/ChangePasswordLayout'
    )
    const { reducer, rootSagas, } = await import(
      /* webpackChunkName: "change-password-modules" */ './ChangePasswordModule'
    )

    injectReducer(store, { key: 'change-password', reducer, })
    injectSagas(store, rootSagas)

    return {
      children: ChangePasswordLayout.default,
    }
  },
  childRoutes: [
    {
      path: '/',
      title: 'change-password.list_title', // Here you can use a plain string o a transalation key
      getComponent: async () => {
        const ChangePasswordView = await import(
          /* webpackChunkName: "change-password-modules" */ './components/ChangePasswordView'
        )
        return {
          children: ChangePasswordView.default,
        }
      },
    },
  ],
})

